// extracted by mini-css-extract-plugin
module.exports = {"title":"HeroCard_title__Patyo","description":"HeroCard_description__imPoe"};